import { css } from "@emotion/core"
import { theme } from "../constants"

export const primaryBannerStyles = css``

const modalTypeStyles = {
  primary: primaryBannerStyles,
}

export const modalStyles = (type) => {
  return css`
    width: 100%;
    background: ${theme.background.modalBg};
    border-radius: ${theme.radii[3]};
    font-family: ${theme.fonts.primary};

    .ant-modal-header {
      background: unset;
      border-bottom: unset;
      border-radius: unset;
      .ant-modal-title {
        color: ${theme.colors.contentText} !important;
        font-weight: 600;
        span {
          font-weight: 600;
        }
      }
    }

    .ant-modal-body span {
      color: ${theme.colors.contentText} !important;
      opacity: 0.9;
    }
    .ant-modal-body {
      color: ${theme.colors.contentText} !important;
      opacity: 0.9;
      .ant-rate {
        svg {
          height: 1.8em;
          width: 1.8em;
        }
      }
      .ant-rate-star-full svg {
        color: ${theme.colors.rating};
      }
    }

    .ant-modal-close {
      display: none;
    }

    .ant-modal-content {
      background: unset;
      -webkit-box-shadow: unset;
      box-shadow: unset;
    }

    .ant-modal-footer {
      display: flex;
      border: unset;
      justify-content: flex-end;
      color: ${theme.colors.contentText} !important;
      padding: 10px 24px;
    }

    ${modalTypeStyles[type]}
  `
}
